import React, { useEffect, useContext, useState } from 'react';
import CreateProfileFirstStep from './CreateProfileFirstStep';
import { store } from 'components/Store';
import CreateProfileAwaits from './CreateProfileAwaits';
import { useAuth0 } from '@auth0/auth0-react';
import Loading from 'components/Login/Loading';
import axios from 'axios';
import getActivePlan from 'components/Settings/Utilities/getActivePlan';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import SecondStepParlamentarian from './SecondStepParliamentarian';
import SignUpCreateATopic from 'components/Login/SignUpCreateATopic';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router';
import getCurrentTeam from 'components/Settings/Team/getCurrentTeam';
import useGetAccessToken from 'components/Dashboard/apiCalls/useGetAccessToken';
import useDashboardUrlCondition from 'components/Dashboard/Navigation/useDashboardUrlCondition';
import CreateProfileGenerateOrganisationDescription from 'components/Login/CreateProfile/CreateProfileGenerateOrganisationDescription';
let changeStep = false;

const CreateProfile = () => {
  const globalState = useContext(store);
  const { dispatch, state } = globalState;
  const { net_api_url, activePlan } = state;

  const { userOnboarded } = activePlan ?? {};
  const params = useParams();
  const { step } = params;

  const location = useLocation();
  const { user } = useAuth0();
  const { getAccessToken } = useGetAccessToken();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { defaultUrl } = useDashboardUrlCondition();

  useEffect(() => {
    const source = new AbortController();
    loadProfile(source);
    return () => {
      source.abort('Create your profile canceled by the user.');
    };
  }, []);

  useEffect(() => {
    if (parseInt(step) !== 4 && userOnboarded && user.email_verified) {
      return navigate(`/${defaultUrl}`, { replace: true });
    } else if (parseInt(step) !== 4 && userOnboarded && !user.email_verified) {
      return navigate('/needs-verification', { replace: true });
    }

    if (changeStep) {
      logAnalitys();
    }
  }, [step, activePlan]);

  const loadProfile = async (source) => {
    try {
      var token = await getAccessToken();
      let activePlanState = Object.keys(activePlan);
      if (activePlanState.length === 0) {
        let activePlan = await getActivePlan(getAccessToken, source);
        activePlanState = activePlan;
        dispatch({ type: 'MODIFY_SECTION', parameter: 'activePlan', value: activePlan });
      } else {
        activePlanState = activePlan;
      }

      let url = `${net_api_url}/api/user/getcurrent`;
      let response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal: source?.signal,
      });
      let result = response.data;
      dispatch({ type: 'MODIFY_SECTION', parameter: 'userProfile', value: result });
      logAnalitys();
      changeStep = true;
      const parliamentarianUserTypes = [
        'Parliamentarian',
        'Parliamentary or political staff',
        'parliamentarian or staff',
      ];
      if (!activePlanState.userOnboarded) {
        if (!!result.userType) {
          let currentTeam = await getCurrentTeam(getAccessToken, source);
          if (!!currentTeam) {
            dispatch({ type: 'MODIFY_SECTION', parameter: 'team', value: currentTeam });
          }
          if (parliamentarianUserTypes.indexOf(result.userType) >= 0) {
            dispatch({ type: 'MODIFY_SECTION', parameter: 'parliamentarianOnboarding', value: true });
            if (result.userType === 'Parliamentarian' && step !== '2-parliamentarian') {
              navigate('/create-your-profile/3');
            } else if (result.userType === 'Parliamentary or political staff') {
              navigate(`/create-your-profile/${!result.organisation ? '2-parliamentarian' : '3'}`);
            }
          } else {
            navigate(
              `/create-your-profile/${
                !!currentTeam?.organisationDescription || result?.userType === 'Lobbying or PR agency' ? '3' : '2'
              }`
            );
          }
        } else {
          if (parseInt(step) !== 1) {
            return window.location.assign('/create-your-profile/1');
          }
        }
      }
      setIsLoading(false);
    } catch (error) {
      if (error.name === 'CanceledError') {
        console.error(error?.config?.signal?.reason);
      } else {
        console.error(error);
      }
    }
  };

  const logAnalitys = () => {
    let title = `Create your profile - PolicyMogul`;
    document.title = title;
    let locationToStorage = {
      title: title,
      storageLocation: { ...location },
    };
    dispatch({ type: 'MODIFY_SECTION', parameter: 'locationToStorage', value: locationToStorage });
  };

  return (
    <>
      {isLoading && <Loading />}

      {!isLoading && (
        <Routes>
          <Route path='3' element={<SignUpCreateATopic />} />
          <Route path=':step/*' element={<FirstAndSecondStep />} />
        </Routes>
      )}
    </>
  );
};

const FirstAndSecondStep = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { parliamentarianOnboarding } = state;
  const params = useParams();
  const { step } = params;

  return (
    <div className='create-profile-container px-0'>
      <div className='scroll-container h-100 create-profile-general-content'>
        <h2 className='company-name'>Policy Mogul</h2>
        <div className='d-flex justify-content-center align-items-center w-100 pt-3 py-lg-5'>
          <div className='mt-5 mt-lg-0'>
            <div
              className={`my-lg-3 create-profile-steps text-center ${step < 4 ? 'mb-3' : ''}`}
              style={{ visibility: step < 3 ? 'visible' : 'hidden' }}
            >
              {!parliamentarianOnboarding && (
                <>
                  <p className='mb-0'>Step {step} of 3</p>
                  <div className={`${step < 3 ? 'mt-2' : ''} create-profile-step create-profile-step-${step}`} />
                </>
              )}
            </div>
            <div className=' p-5 create-profile-content'>
              {step === '1' && <CreateProfileFirstStep />}
              {step === '2' && <CreateProfileGenerateOrganisationDescription />}
              {step === '2-parliamentarian' && <SecondStepParlamentarian />}
              {step === '4' && <CreateProfileAwaits />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAuthenticationRequired(CreateProfile, {
  onRedirecting: () => <Loading />,
});
